module.exports = __webpack_public_path__ + "static/media/bg.50f15a1c.jpg";